// CRO PDP - consolidated non-Liquid JS
(function(){
  if (window.__CRO_PDP_LOADED__) return;
  window.__CRO_PDP_LOADED__ = true;

  // Title clamp toggle
  function setupTitleToggle(){
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('h1.product__title');
    if (!titleEl) return;
    if (document.querySelector('.cro-title-toggle')) return;
    requestAnimationFrame(function(){
      var clamped = titleEl.scrollHeight > titleEl.clientHeight + 2 || titleEl.scrollWidth > titleEl.clientWidth + 2;
      if (!clamped) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cro-title-toggle';
      btn.textContent = 'Show more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function(){
        var expanded = titleEl.classList.toggle('cro-title-expanded');
        btn.textContent = expanded ? 'Show less' : 'Show more';
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
      titleEl.parentElement.insertBefore(btn, titleEl.nextSibling);
    });
  }

  // Amazon-style image zoom — swipeable carousel + REAL pinch-zoom + pan
  function setupImageZoom(){
    if (window.__CRO_IMG_ZOOM_LOADED__) return;
    window.__CRO_IMG_ZOOM_LOADED__ = true;

    function gatherImages(){
      var nodes = document.querySelectorAll('.product__media-item:not(.thumbnail-list__item) img, .product__media img');
      var seen = {};
      var imgs = [];
      nodes.forEach(function(el){
        var src = el.getAttribute('data-zoom') || el.currentSrc || el.src;
        if (!src) return;
        var key = src.split('?')[0].replace(/_(\d+)x(\d+)?(?=\.[a-z]+$)/, '');
        if (seen[key]) return;
        seen[key] = true;
        var hi = src.replace(/_(\d+)x(\d+)?/, '_1800x').replace(/width=\d+/, 'width=1800');
        imgs.push({ src: hi, alt: el.alt || '' });
      });
      return imgs;
    }

    var overlay = document.createElement('div');
    overlay.id = 'cro-zoom-overlay';
    overlay.innerHTML = ''
      + '<button type="button" id="cro-zoom-close" aria-label="Close">'
      +   '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>'
      + '</button>'
      + '<div id="cro-zoom-counter"><span id="cro-zoom-current">1</span> / <span id="cro-zoom-total">1</span></div>'
      + '<div id="cro-zoom-track"></div>'
      + '<button type="button" id="cro-zoom-prev" aria-label="Previous">&#x2039;</button>'
      + '<button type="button" id="cro-zoom-next" aria-label="Next">&#x203a;</button>';
    document.body.appendChild(overlay);

    var track = overlay.querySelector('#cro-zoom-track');
    var counterCur = overlay.querySelector('#cro-zoom-current');
    var counterTot = overlay.querySelector('#cro-zoom-total');
    var prevBtn = overlay.querySelector('#cro-zoom-prev');
    var nextBtn = overlay.querySelector('#cro-zoom-next');
    var closeBtn = overlay.querySelector('#cro-zoom-close');

    var images = [];
    var currentIdx = 0;
    // Per-slide zoom state: index -> { scale, x, y }
    var slideState = {};
    var MAX_SCALE = 4;
    var MIN_SCALE = 1;

    function getState(i){
      if (!slideState[i]) slideState[i] = { scale: 1, x: 0, y: 0 };
      return slideState[i];
    }

    function applyTransform(slide, st, animate){
      var img = slide.querySelector('img');
      if (!img) return;
      img.style.transition = animate ? 'transform 0.22s ease' : 'none';
      img.style.transform = 'translate3d(' + st.x + 'px, ' + st.y + 'px, 0) scale(' + st.scale + ')';
      slide.classList.toggle('is-zoomed', st.scale > 1.02);
    }

    function clampPan(slide, st){
      var img = slide.querySelector('img');
      if (!img) return;
      // After scale, the image rendered size = naturalDisplayed * scale
      // Use the actual rendered (post-object-fit) dimensions
      var rect = img.getBoundingClientRect();  // rect already includes the transform; recompute pre-transform
      // Simpler: use slide rect as viewport, compute max pan = (img.naturalW * scale - slide.W) / 2
      var slideRect = slide.getBoundingClientRect();
      var imgW = img.naturalWidth || img.clientWidth;
      var imgH = img.naturalHeight || img.clientHeight;
      // Image is rendered as object-fit:contain inside slide
      var fitScale = Math.min(slideRect.width / imgW, slideRect.height / imgH);
      var renderedW = imgW * fitScale * st.scale;
      var renderedH = imgH * fitScale * st.scale;
      var maxX = Math.max(0, (renderedW - slideRect.width) / 2);
      var maxY = Math.max(0, (renderedH - slideRect.height) / 2);
      st.x = Math.max(-maxX, Math.min(maxX, st.x));
      st.y = Math.max(-maxY, Math.min(maxY, st.y));
    }

    function render(){
      track.innerHTML = images.map(function(im, i){
        return '<div class="cro-zoom-slide" data-i="'+i+'"><img src="'+im.src+'" alt="'+(im.alt||'').replace(/"/g, '&quot;')+'" draggable="false"/></div>';
      }).join('');
      counterTot.textContent = images.length;
      // Reset all slide state
      slideState = {};
      goTo(currentIdx, true);
    }

    function updateArrows(){
      prevBtn.style.display = currentIdx > 0 ? '' : 'none';
      nextBtn.style.display = currentIdx < images.length - 1 ? '' : 'none';
    }

    function goTo(i, instant){
      if (i < 0 || i >= images.length) return;
      // Reset zoom on the slide we're leaving
      var prev = track.querySelector('.cro-zoom-slide[data-i="'+currentIdx+'"]');
      if (prev) {
        slideState[currentIdx] = { scale: 1, x: 0, y: 0 };
        applyTransform(prev, slideState[currentIdx], false);
      }
      currentIdx = i;
      counterCur.textContent = i + 1;
      var off = -i * 100;
      track.style.transition = instant ? 'none' : 'transform 0.3s ease';
      track.style.transform = 'translateX(' + off + '%)';
      updateArrows();
    }

    function open(startIdx){
      images = gatherImages();
      if (images.length === 0) return;
      currentIdx = Math.max(0, Math.min(startIdx || 0, images.length - 1));
      render();
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function(e){
      if (e.target === overlay) close();
    });
    prevBtn.addEventListener('click', function(e){ e.stopPropagation(); goTo(currentIdx - 1); });
    nextBtn.addEventListener('click', function(e){ e.stopPropagation(); goTo(currentIdx + 1); });
    document.addEventListener('keydown', function(e){
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') goTo(currentIdx - 1);
      if (e.key === 'ArrowRight') goTo(currentIdx + 1);
    });

    // === Touch gesture engine: pinch-to-zoom + pan + swipe + double-tap ===
    var gesture = null; // { type: 'pinch' | 'pan' | 'swipe', ... }
    var lastTap = 0;
    var lastTapX = 0;
    var lastTapY = 0;

    function getCurrentSlide(){
      return track.querySelector('.cro-zoom-slide[data-i="'+currentIdx+'"]');
    }
    function midpoint(a, b){
      return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 };
    }
    function distance(a, b){
      var dx = a.clientX - b.clientX, dy = a.clientY - b.clientY;
      return Math.sqrt(dx*dx + dy*dy);
    }

    track.addEventListener('touchstart', function(e){
      var slide = getCurrentSlide();
      if (!slide) return;
      var st = getState(currentIdx);
      if (e.touches.length === 2) {
        // Begin pinch
        e.preventDefault();
        var t0 = e.touches[0], t1 = e.touches[1];
        var mid = midpoint(t0, t1);
        var rect = slide.getBoundingClientRect();
        gesture = {
          type: 'pinch',
          startDist: distance(t0, t1),
          startScale: st.scale,
          startX: st.x,
          startY: st.y,
          // Anchor point relative to slide center, in image space
          cx: mid.x - (rect.left + rect.width / 2),
          cy: mid.y - (rect.top + rect.height / 2),
        };
      } else if (e.touches.length === 1) {
        var t = e.touches[0];
        if (st.scale > 1.02) {
          // Begin pan
          gesture = {
            type: 'pan',
            startTouchX: t.clientX, startTouchY: t.clientY,
            startX: st.x, startY: st.y,
          };
        } else {
          // Maybe swipe to navigate
          gesture = {
            type: 'swipe',
            startTouchX: t.clientX, startTouchY: t.clientY,
          };
        }
      }
    }, { passive: false });

    track.addEventListener('touchmove', function(e){
      if (!gesture) return;
      var slide = getCurrentSlide();
      if (!slide) return;
      var st = getState(currentIdx);
      if (gesture.type === 'pinch' && e.touches.length >= 2) {
        e.preventDefault();
        var t0 = e.touches[0], t1 = e.touches[1];
        var newDist = distance(t0, t1);
        var ratio = newDist / gesture.startDist;
        var newScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, gesture.startScale * ratio));
        // Keep the gesture-center anchored on the same image pixel
        st.scale = newScale;
        // Compute new translation so that the anchor stays under the user's fingers
        var growRatio = newScale / gesture.startScale;
        st.x = gesture.startX * growRatio + gesture.cx * (1 - growRatio);
        st.y = gesture.startY * growRatio + gesture.cy * (1 - growRatio);
        clampPan(slide, st);
        applyTransform(slide, st, false);
      } else if (gesture.type === 'pan' && e.touches.length === 1) {
        e.preventDefault();
        var t = e.touches[0];
        st.x = gesture.startX + (t.clientX - gesture.startTouchX);
        st.y = gesture.startY + (t.clientY - gesture.startTouchY);
        clampPan(slide, st);
        applyTransform(slide, st, false);
      }
    }, { passive: false });

    track.addEventListener('touchend', function(e){
      var slide = getCurrentSlide();
      if (!slide) { gesture = null; return; }
      var st = getState(currentIdx);
      if (gesture && gesture.type === 'pinch') {
        // If snapped back below threshold, fully reset
        if (st.scale < 1.05) {
          st.scale = 1; st.x = 0; st.y = 0;
          applyTransform(slide, st, true);
        }
      } else if (gesture && gesture.type === 'swipe' && e.changedTouches.length === 1) {
        var t = e.changedTouches[0];
        var dx = t.clientX - gesture.startTouchX;
        var dy = t.clientY - gesture.startTouchY;
        if (st.scale <= 1.02 && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) goTo(currentIdx + 1);
          else goTo(currentIdx - 1);
        }
      }
      gesture = null;
    }, { passive: true });

    // Desktop: click-drag pan while zoomed (no auto-zoom anywhere — user must pinch on mobile to zoom)
    var dragging = null;
    track.addEventListener('mousedown', function(e){
      var slide = getCurrentSlide();
      if (!slide) return;
      var st = getState(currentIdx);
      if (st.scale <= 1.02) return;
      e.preventDefault();
      dragging = { startX: e.clientX, startY: e.clientY, origX: st.x, origY: st.y };
    });
    window.addEventListener('mousemove', function(e){
      if (!dragging) return;
      var slide = getCurrentSlide();
      if (!slide) return;
      var st = getState(currentIdx);
      st.x = dragging.origX + (e.clientX - dragging.startX);
      st.y = dragging.origY + (e.clientY - dragging.startY);
      clampPan(slide, st);
      applyTransform(slide, st, false);
    });
    window.addEventListener('mouseup', function(){ dragging = null; });

    // Bind tap on each product image
    document.querySelectorAll('.product__media img, media-gallery img').forEach(function(el){
      el.style.cursor = 'zoom-in';
      el.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var all = Array.from(document.querySelectorAll('.product__media img, media-gallery img'));
        open(all.indexOf(el));
      }, { capture: true });
    });
  }

  // Sticky cart: only visible AFTER user scrolls past the inline ATC (never visible above the fold)
  function setupStickyVisibility(){
    var sticky = document.getElementById('cro-sticky-cart');
    var inlineBtn = document.querySelector('.product-form__submit, button[name="add"]');
    var stickyCta = document.getElementById('cro-sticky-cta');
    if (!sticky || !inlineBtn) return;
    if (sticky.parentElement !== document.body) document.body.appendChild(sticky);
    sticky.style.display = 'flex';
    sticky.classList.remove('visible');
    if (stickyCta && !stickyCta.dataset.croWired) {
      stickyCta.dataset.croWired = '1';
      stickyCta.addEventListener('click', function(){ inlineBtn.click(); });
    }
    if (sticky.dataset.croScrollWired) return;
    sticky.dataset.croScrollWired = '1';

    // Show sticky only when the inline ATC has been scrolled OUT OF VIEW above the viewport
    // (i.e. user has scrolled past it). At any point where the ATC is still visible or below,
    // sticky stays hidden — so it's never visible above the fold.
    var ticking = false;
    function update(){
      ticking = false;
      var r = inlineBtn.getBoundingClientRect();
      // ATC bottom must be ABOVE the viewport top — meaning user scrolled past it entirely
      if (r.bottom < 0) sticky.classList.add('visible');
      else sticky.classList.remove('visible');
    }
    function onScroll(){
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  // Sticky price update
  function updateStickyPrice(){
    var priceEl = document.querySelector('.price--on-sale .price-item--sale.price-item--last')
              || document.querySelector('.price--on-sale .price-item--sale')
              || document.querySelector('.price__regular .price-item--regular')
              || document.querySelector('.price-item');
    var cta = document.getElementById('cro-sticky-cta');
    var saleEl = document.querySelector('#cro-sticky-cart .sticky-price .sale');
    if (priceEl) {
      if (cta) cta.setAttribute('data-price', priceEl.textContent.trim());
      if (saleEl) saleEl.textContent = priceEl.textContent.trim();
    }
  }

  // Cart icon swap to classic shopping cart with wheels
  function swapCartIcon(){
    var CART_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="22" height="22" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    document.querySelectorAll('.header__icon--cart .svg-wrapper').forEach(function(w){
      if (w.dataset.croSwapped) return;
      w.innerHTML = CART_SVG;
      w.dataset.croSwapped = '1';
    });
  }

  // Desktop gallery arrow wire-up
  // 2026-10-08: arrows step through VISIBLE slides only (cro-variant-images.js hides other colours with an inline
  // display:none; the colour-group gallery on e.g. the kettles uses the .cg-hide class), via Dawn's own media-gallery.setActiveMedia(); the "current / total" counter + arrow disabled
  // state are re-synced on arrows, thumbnail clicks, variant changes and gallery class/style changes.
  function croVisibleSlides(viewer){
    return Array.prototype.filter.call(viewer.querySelectorAll('.product__media-item'), function(li){
      return li.style.getPropertyValue('display') !== 'none' && !li.classList.contains('cg-hide') && !li.hidden;
    });
  }
  function croActiveIdx(vis){
    for (var i = 0; i < vis.length; i++) if (vis[i].classList.contains('is-active')) return i;
    return 0;
  }
  function croSyncDesktopGallery(){
    if (window.innerWidth < 990) return;
    var viewer = document.querySelector('media-gallery [id^="GalleryViewer"]');
    if (!viewer) return;
    var vis = croVisibleSlides(viewer);
    if (!vis.length) return;
    var idx = croActiveIdx(vis);
    var cur = viewer.querySelector('.slider-counter--current'), tot = viewer.querySelector('.slider-counter--total');
    if (cur && cur.textContent !== String(idx + 1)) cur.textContent = idx + 1;
    if (tot && tot.textContent !== String(vis.length)) tot.textContent = vis.length;
    var prev = viewer.querySelector('.slider-button--prev'), next = viewer.querySelector('.slider-button--next');
    if (prev) prev.disabled = idx <= 0;
    if (next) next.disabled = idx >= vis.length - 1;
  }
  function setupDesktopArrows(){
    if (window.innerWidth < 990 || window.__croArrowsWired) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || !gallery.querySelector('[id^="GalleryViewer"] .slider-button--next')) return;
    window.__croArrowsWired = true;
    document.addEventListener('click', function(e){
      var btn = e.target && e.target.closest && e.target.closest('media-gallery [id^="GalleryViewer"] .slider-button--prev, media-gallery [id^="GalleryViewer"] .slider-button--next');
      if (!btn || window.innerWidth < 990) return;
      e.preventDefault(); e.stopPropagation();
      var g = btn.closest('media-gallery'), viewer = btn.closest('[id^="GalleryViewer"]');
      var vis = croVisibleSlides(viewer);
      var to = croActiveIdx(vis) + (btn.classList.contains('slider-button--next') ? 1 : -1);
      if (to < 0 || to >= vis.length) return;
      var id = vis[to].getAttribute('data-media-id');
      if (g && typeof g.setActiveMedia === 'function' && id) g.setActiveMedia(id, false);
      else vis.forEach(function(li, i){ li.classList.toggle('is-active', i === to); });
      croSyncDesktopGallery();
    }, true);
    document.addEventListener('click', function(e){
      if (e.target && e.target.closest && e.target.closest('.thumbnail-list__item')) setTimeout(croSyncDesktopGallery, 80);
    });
    document.addEventListener('change', function(){ setTimeout(croSyncDesktopGallery, 400); });
    try {
      var t;
      new MutationObserver(function(){ clearTimeout(t); t = setTimeout(croSyncDesktopGallery, 60); })
        .observe(gallery, { attributes: true, attributeFilter: ['class', 'style'], subtree: true });
    } catch (err) {}
    croSyncDesktopGallery();
  }



  // CX 2026-10-02: duplicate desktop-header builder removed (cro-header.js is the single source)

  function init(){
    setupTitleToggle();
    setupStickyVisibility();
    updateStickyPrice();
    setTimeout(syncStickyFromMain, 600);
    swapCartIcon();
    setupDesktopArrows();
    setupImageZoom();
  }

  // 2026-10-08: keep the desktop sticky bar in step with the selected variant (Saran approved).
  // Before this, its colour dropdown always showed the first option and its thumbnail was always the
  // product's featured image. Generic: reads the main form's variant id + the sticky's own product JSON,
  // never dispatches events (so it cannot loop with the sticky -> main-form sync in product.json).
  function syncStickyFromMain(){
    var dataEl = document.getElementById('cro-sticky-product-data');
    var box = document.getElementById('cro-sticky-variants');
    if (!dataEl || !box) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var idEl = document.querySelector('form[action*="/cart/add"] input[name="id"]:not([form])')
            || document.querySelector('input[name="id"]:not([form])')
            || document.querySelector('select[name="id"]:not([form])');
    if (!idEl || !idEl.value) return;
    var v = (data.variants || []).find(function(x){ return String(x.id) === String(idEl.value); });
    if (!v) return;
    box.querySelectorAll('[data-sticky-option]').forEach(function(el, i){
      if (v.options[i] !== undefined && el.value !== v.options[i]) el.value = v.options[i];
    });
    // thumbnail = first gallery image still visible for this variant (the colour filter hides the others)
    var img = document.querySelector('#cro-sticky-cart .sticky-left img');
    if (!img) return;
    var items = document.querySelectorAll('.product__media-item');
    for (var k = 0; k < items.length; k++) {
      var it = items[k];
      if (it.style.display === 'none' || it.classList.contains('cg-hide')) continue;
      var pic = it.querySelector('img');
      var src = pic && (pic.currentSrc || pic.src);
      if (src) { img.src = src.replace(/([?&])width=\d+/, '$1width=120'); img.removeAttribute('srcset'); }
      break;
    }
  }

  document.addEventListener('change', function(e){
    if (e.target && (e.target.name === 'id' || e.target.closest('variant-radios, variant-selects, fieldset.product-form__input'))) {
      setTimeout(updateStickyPrice, 200);
      setTimeout(syncStickyFromMain, 500);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  setTimeout(swapCartIcon, 400);
  setTimeout(swapCartIcon, 1500);
  setTimeout(setupStickyVisibility, 800);


  // === BWA delivery block: listen for postMessage from Amazon iframe ===
  // BWA sends {type:"bwa-delivery-block-rendered", height:N, isInStock:bool} when ready.
  // If isInStock: true AND height > 0 → Amazon CAN deliver this product → hide our timeline.
  // If no message within 6s OR isInStock: false → keep our timeline, hide empty BWA wrapper.

})();
